<template>
  <div class="prog-container border-b-light">
    <div class="prog-inner">
      <div v-show="this.seconds" class="percent-container">
        <div class="percent">{{ secs }} {{ $t("times.second") }}</div>
      </div>
      <progressBar
        :percentage="percent"
        :show="show"
        loadingClass="fsloadingbar"
        :stopAnimation="stopAnimation"
      />
    </div>
    <footer class="footer flex-bet rtl">
      <span class="message">{{ message }} {{ search }}</span>
      <BaseButton @click.stop="stopSearch()">{{
        $t("freeSearchResults.stop")
      }}</BaseButton>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ["percent", "search", "seconds", "stopAnimation", "message", "show"],
  data() {
    return { time: 2000 };
  },
  components: {},
  computed: {
    secs() {
      return !this.seconds ? "" : this.seconds.toFixed(2); //.toFixed();
    },
  },
  methods: {
    //  ...mapActions("freeSearch", ["setSearching"]),
    stopSearch() {
      // this.setSearching(false);
      this.$emit("stop");
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-color1: #fff;
.prog-container {
  width: 100%;
  height: 80px;
  background-color: $bg-color1;
  position: absolute;
  z-index: 100;
  display: flex;
  flex-direction: column;
}
.prog-inner {
  padding: 0 15px;
  width: 100%;
  // height: 50px;
  // background-color: $bg-color1;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.percent-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.percent {
  padding-top: 10px;
  font-size: 15px;
  font-weight: bold;
  color: var(--custom-color1);
}
.footer {
  background-color: transparent;
  height: 30px;
  margin-top: 10px;
  padding: 0px 15px;
}
.message {
  color: rgba(0, 0, 0, 0.7);
  // font-size: 12px;
  padding-right: 7px;
}
.btn-stop {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
}
</style>
